import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';

export const Container = styled(Stack)`
  display: none;
  width: 100%;
  border-radius: 8px;
  opacity: 0;
  transition: all ease-in-out 150ms;
  visibility: hidden;

  &:hover {
    cursor: pointer;
  }

  &.is-visible {
    display: flex;
    opacity: 0.8;
    visibility: visible;
  }
`;
